var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99674 1.99924H3.33185C2.97836 1.99924 2.63935 2.13966 2.3894 2.38961C2.13945 2.63957 1.99902 2.97857 1.99902 3.33206V12.6618C1.99902 13.0153 2.13945 13.3543 2.3894 13.6043C2.63935 13.8542 2.97836 13.9947 3.33185 13.9947H12.6616C13.0151 13.9947 13.3541 13.8542 13.6041 13.6043C13.854 13.3543 13.9944 13.0153 13.9944 12.6618V7.99695",
    stroke: "#4A5565",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2453 1.74932C12.5104 1.48421 12.87 1.33527 13.2449 1.33527C13.6199 1.33527 13.9794 1.48421 14.2445 1.74932C14.5097 2.01444 14.6586 2.37401 14.6586 2.74894C14.6586 3.12387 14.5097 3.48344 14.2445 3.74856L8.23817 9.7556C8.07993 9.91371 7.88444 10.0294 7.66972 10.0921L5.75512 10.6519C5.69777 10.6687 5.63699 10.6697 5.57912 10.6548C5.52126 10.64 5.46844 10.6099 5.42621 10.5677C5.38397 10.5254 5.35386 10.4726 5.33904 10.4147C5.32421 10.3569 5.32522 10.2961 5.34194 10.2388L5.90173 8.32415C5.96472 8.1096 6.08068 7.91434 6.23893 7.75636L12.2453 1.74932Z",
    stroke: "#4A5565",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6d437f5edbdeb97087238addfd4b059e.svg";
export { ForwardRef as ReactComponent };